<template>
  <main class="mobile-page login-screen">
    <div class="mobile-screen">
      <header class="mobile-topnav">
        <RouterLink class="mobile-icon-btn" to="/mobile/user" aria-label="返回我的">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M14.5 5.5 8 12l6.5 6.5" /></svg>
        </RouterLink>
        <span class="mobile-topnav-title">登录</span>
        <i class="nav-space"></i>
      </header>

      <section class="login-brand">
        <i class="login-mark"><svg width="30" height="30" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="3.2" fill="#04110f" /><circle cx="12" cy="12" r="8" stroke="#04110f" stroke-width="1.8" opacity=".55" /></svg></i>
        <span class="mobile-eyebrow">Account · 账号登录</span>
        <h1>点指之间账号</h1>
        <p>登录后继续管理订单、地址与账号服务</p>
      </section>

      <form @submit.prevent="submit">
        <label>
          <span>手机号</span>
          <input v-model.trim="phone" type="tel" inputmode="numeric" autocomplete="tel" maxlength="11" placeholder="请输入 11 位手机号" />
        </label>
        <label>
          <span>密码</span>
          <input v-model="password" type="password" autocomplete="current-password" placeholder="请输入密码" />
        </label>
        <p v-if="message" class="message" role="alert">{{ message }}</p>
        <button class="mobile-btn mobile-btn-primary" type="submit" :disabled="loading">{{ loading ? '正在登录' : '登录' }}</button>
      </form>

      <p class="foot">登录即表示已阅读并同意平台相关协议</p>
    </div>
  </main>
</template>

<script setup>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { loginWithPassword } from '@/api/auth'

const route = useRoute()
const router = useRouter()
const phone = ref(localStorage.getItem('dzzj_website_phone') || '')
const password = ref('')
const loading = ref(false)
const message = ref('')

async function submit() {
  if (!/^1[3-9]\d{9}$/.test(phone.value)) {
    message.value = '请输入正确的 11 位手机号。'
    return
  }
  if (!password.value) {
    message.value = '请输入密码。'
    return
  }
  loading.value = true
  message.value = ''
  try {
    const token = await loginWithPassword(phone.value, password.value)
    localStorage.setItem('dzzj_website_token', token.access_token)
    const refreshToken = token.refresh_token || token.refreshToken
    if (refreshToken) localStorage.setItem('dzzj_website_refresh_token', refreshToken)
    localStorage.setItem('dzzj_website_phone', phone.value)
    await router.push(typeof route.query.redirect === 'string' && route.query.redirect.startsWith('/mobile') ? route.query.redirect : '/mobile/user')
  } catch (error) {
    message.value = error.message || '登录失败'
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.login-screen { padding-bottom: calc(80px + env(safe-area-inset-bottom)); }
.nav-space { width: 36px; flex: 0 0 36px; }
.login-brand { display: flex; flex-direction: column; align-items: center; padding: 34px 0 24px; text-align: center; }
.login-mark { width: 64px; height: 64px; display: flex; align-items: center; justify-content: center; margin-bottom: 16px; border-radius: 20px; background: radial-gradient(circle at 30% 25%, #8df5de, #46d6b6 60%, #2eb898); box-shadow: 0 14px 44px rgba(70,214,182,.4); }
.login-brand h1 { margin: 12px 0 7px; font-size: 22px; font-weight: 900; letter-spacing: .02em; }
.login-brand p { color: var(--mobile-quiet); font-size: 11px; letter-spacing: .05em; }
form { display: grid; gap: 13px; }
label { display: grid; gap: 6px; }
label span { color: var(--mobile-quiet); font-size: 11.5px; font-weight: 700; }
input { width: 100%; min-height: 48px; padding: 0 14px; border: 1px solid var(--mobile-line); border-radius: 12px; color: var(--mobile-ink); background: rgba(255,255,255,.035); outline: none; }
input:focus { border-color: rgba(98,244,214,.55); box-shadow: 0 0 0 3px rgba(98,244,214,.08); }
.message { color: #ff9c9c; font-size: 12px; }
.foot { padding: 20px 0; color: var(--mobile-faint); font-size: 10px; text-align: center; line-height: 1.8; }
</style>
